<template>
  <div class="app-header" :style="{ paddingTop: safeArea.top + 'px' }">
    <div class="app-header-bar">
      <!-- 左侧：返回按钮 -->
      <div class="app-header-back" v-if="showBack" @click="onBack">
        <img src="../../assets/imgs/icon_back.png" alt="" />
      </div>
      <div class="app-header-back app-header-back-placeholder" v-else></div>

      <!-- 中间：标题 -->
      <div class="app-header-title">
        <slot>{{ title }}</slot>
      </div>

      <!-- 右侧：自定义 slot -->
      <div class="app-header-right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"
export default {
  name: "AppHeader",
  props: {
    // 标题文字
    title: { type: String, default: "" },
    // 是否显示返回按钮
    showBack: { type: Boolean, default: true }
  },
  computed: {
    ...mapState(["safeArea"])
  },
  methods: {
    onBack() {
      if (this.$listeners.back) {
        this.$emit("back")
      } else {
        // 默认行为：返回上一页；无历史时兜底跳主页 /map（与 BottomNav 一致）
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push("/map")
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.app-header {
  width: 100%;
  background: #fff;
  position: relative;
  z-index: 100;

  &-bar {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 120px; // App 端 AppBar 默认高度
  }

  &-back {
    position: absolute;
    left: 30px;
    top: 50%;
    transform: translateY(-50%);
    width: 52px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 2;

    img {
      width: 56px;
      height: 56px;
      display: block;
    }
  }

  &-back-placeholder {
    visibility: hidden;
  }

  &-title {
    flex: 1;
    text-align: center;
    font-size: 48px;
    font-weight: 600;
    color: #000;
    font-family: "Montserrat-SemiBold", sans-serif;
    line-height: 1;
    padding: 0 100px; // 给左右留出按钮位置
    box-sizing: border-box;
  }

  &-right {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
  }
}
</style>
